/** DM alert sound (public/message_alert.wav). */
let sharedAudio = null;

function getAudio() {
  if (typeof window === "undefined") return null;
  if (!sharedAudio) {
    sharedAudio = new Audio("/message_alert.wav");
    sharedAudio.volume = 0.5;
  }
  return sharedAudio;
}

export function playDmSound() {
  try {
    const audio = getAudio();
    if (!audio) return;
    audio.currentTime = 0;
    void audio.play().catch(() => {
      /* autoplay / user-gesture restrictions */
    });
  } catch {
    /* ignore */
  }
}
